module.exports = __webpack_public_path__ + "static/media/kids-see-ghosts-album-art-2018-billboard-1240@2x.2203ab17.png";